// extracted by mini-css-extract-plugin
module.exports = {"accordion":"Breakdown-module__accordion___Amb9j","totalPriceFooter":"Breakdown-module__totalPriceFooter___0A6ix"};